(function() {
    angular
        .module("customersModule")
        .config(customersRouter)

    customersRouter.$inject = [
        "$stateProvider",
        "$urlRouterProvider",
        "$locationProvider"
    ]

    function customersRouter(
        $stateProvider,
        $urlRouterProvider,
        $locationProvider
    ){

        $stateProvider
            .state("customers", {
                url: "/customers",
                templateUrl: "app/components/customers/customers.view.html",
                controller : "CustomersController"
            })
            .state("customer-customers", {
                url: "/customers/customer-id/:customer_id",
                templateUrl: "app/components/customers/customers.view.html",
                controller : "CustomersController"
            })
            .state("customer-details", {
                url: "/customer-details/id/:customer_id",
                templateUrl: "app/components/customers/details.view.html",
                controller : "CustomerDetailsController"
            })
            .state("customer-new", {
                url: "/customer-new",
                templateUrl: "app/components/customers/new.view.html",
                controller : "CustomerNewController"
            })

            $urlRouterProvider.otherwise("/")

        $locationProvider.html5Mode(true)
    }
})()
